module.exports = __webpack_public_path__ + "img/flag.8d158a0e.png";